import React, { Component, Fragment } from "react";
import _ from "lodash";
import './Site.css';
import { api, chartHelper } from "../helpers";
import ToggleButton from "react-toggle-button";
import {
  BarChart,
  IngredientDataCard,
  Pager
 } from '../components';
import {
  Row,
  Col,
  Button,
  ButtonGroup,
  Table
} from 'reactstrap';
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { constant }from "../helpers";
import moment from "moment";

const sortList = [
  {
    value: 1,
      label: "Detected Concentration Greater Than Zero",
  },
  {
    value: 2,
    label: "Passed Ingredients",
  },
  {
    value: 3,
    label: "Failed Ingredients",
    },
  {
    value: 4,
      label: "Show 'Not Detected' Ingredients",
    }
];

export default class CoaResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productData: props.data,
      hideIngredientTest: false,
      filterIngredientValue: null,
      requestProductLogs: [],
    testTypeList: [],
    filterTestTypeValue: null
    }
    this.onChange = this.onChange.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.GetRequestProductLogsGroup = this.GetRequestProductLogsGroup.bind(this);
    this.GetCOATestTypes = this.GetCOATestTypes.bind(this);
      this.onTestTypeSelect = this.onTestTypeSelect.bind(this);
      this.onClearFilters = this.onClearFilters.bind(this);
  }

  GetRequestProductLogsGroup = () =>
  api
    .fetch(`COA/GetRequestProductLogsGroup/${this.state.productData.coaRequestProductId}`)
    .then(response => {
      return ({
        requestProductLogs: response.data
      })
    })
    .catch(x => console.error(x));

  GetCOATestTypes = () =>
  api.fetch(`Reference/COATestTypes`)
    .then(response => {
        let list = _.map(response.data, d => {
            return {
                label: d.name,
                value: d.id
            }
        });
      return ({
        testTypeList: list
      })
    })
    .catch(x => console.error(x));

  componentDidMount() {
      Promise.all([this.GetRequestProductLogsGroup(), this.GetCOATestTypes()])
          .then(response => {
              let newStatus = {};
              _.each(response, r => Object.assign(newStatus, r));
              this.setState(newStatus );
        })
    }

    onChange(applyZeroValueFilter) {
    let list = this.state.productData.prestineResultList.slice();
    if (applyZeroValueFilter) {
      list = _.reject(list, l => l.concentration === 0 || !l.concentration)
    }
    this.setState({
      productData: {
        ...this.state.productData,
        results: list
      }
    })
  };

  onSelectChange(selection) {
      let list = this.state.filterTestTypeValue
          ? this.state.productData.results.slice()
          : this.state.productData.prestineResultList.slice();
    if (selection.label === "Detected Concentration Greater Than Zero") {
        list = _.reject(list, l => { return !l.concentration || l.concentration < 0 })
    }
    if (selection.label === "Passed Ingredients") {
        list = _.filter(list, l => l.passed === true || l.passed === null)
    }
    if (selection.label === "Failed Ingredients") {
        list = _.filter(list, l => { return l.passed === false })
    }
    if (selection.label === "Show 'Not Detected' Ingredients") {
        list = _.reject(list, l => !l.notDetected)
    } else {
    list = _.filter(list, l => { return l.includeInCOAReport }) 
    }
    //default filters removes ingredients marked not marked for reports
     list = _.sortBy(list, ['testTypeName', 'ingredientName'])
    this.setState({
      productData: {
        ...this.state.productData,
        results: list
      },
      filterIngredientValue: selection
    })
    }

    onTestTypeSelect(selection) {
        let list = this.state.filterIngredientValue
            ? this.state.productData.results.slice()
            : this.state.productData.prestineResultList.slice();

        if (selection.value !== 0) {
            list = _.reject(list, l => { return l.testTypeId !== selection.value });
        } 
        list = _.sortBy(list, ['testTypeName', 'ingredientName'])
        this.setState({
            productData: {
                ...this.state.productData, results: list
            },
            filterTestTypeValue: selection
        })
    }
    onClearFilters(){
        let list = this.state.productData.prestineResultList.slice();
        list = _.sortBy(list, ['testTypeName', 'ingredientName'])
        this.setState({
            productData: {
                ...this.state.productData, results: list
            },
            filterTestTypeValue: null,
            filterIngredientValue: null
        })
    }
  render() {
    const {
      productData,
      filterIngredientValue,
      hideIngredientTest,
        requestProductLogs,
        filterTestTypeValue,
        testTypeList
    } = this.state;
    const colorList = productData
      ? chartHelper.getListOfRandomHexColors(productData.results.length)
      : chartHelper.getListOfRandomHexColors();
    return (
      <div className="ml-4 mr-4">
        {productData &&
          <React.Fragment>
            <Row style={{justifyContent:'end'}}>
                <Col xs="4">
                  <Select
                    closeMenuOnSelect={true}
                    isClearable={true}
                    //components={makeAnimated()}
                    options={_.map(constant.VerificationStatus, vs => ({...vs}))}
                    onChange={(e)=>this.props.verificationChange(e, this.state.productData)}
                    value={_.find(constant.VerificationStatus, vs => (vs.value === productData.verificationStatusId))}
                    onBlurResetsInput={false}
                    onSelectResetsInput={false}
                    onCloseResetsInput={false}
                    classNamePrefix="react-select"
                    placeholder={"Select type of verification"}
                  />  
                  </Col>
                <Col xs="1">
                <ButtonGroup className={"float-right"}>
                  {/* <Button size="sm" className={productData.checkedAt ? "cbdmdPrimaryOutline buttonGroupSpacing" : "cbdmdPrimary buttonGroupSpacing"} onClick={ ()=>this.props.markVerified(productData.coaRequestProductId)}>
                    {productData.checkedAt ? "Mark Un-Verified" : "Mark Verified"}
                  </Button> */}
                  <Button size="sm" color="dark" title="Download COA" className="buttonGroupSpacing" onClick={ ()=>this.props.downloadReport(productData.coaRequestProductId)}>
                    <FontAwesomeIcon icon="download" />
                  </Button>
                </ButtonGroup>
                </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <h5>Product Results</h5>
                  <BarChart
                    label={"Concentration Amount"}
                    xAxisLabels={productData.results.map(l => l.ingredientName)}
                    data={productData.results.map(d => Number.parseFloat(d.concentration).toFixed(2))}
                    borderColor={colorList}
                    hoverBorderColor={colorList}
                    display={true}
                    text={"Coa Product Results"}
                    options={{
                        responsive: true,
                        maintainAspectRatio: true,
                    }}
                  />
              </Col>
          </Row>
            <Row className="mt-4 mb-2">
              <Col>
                <Button
                  className={`${hideIngredientTest ? "cbdmdPrimaryOutline" : "cbdmdPrimary"} float-left`}
                  onClick={() => this.setState({ hideIngredientTest: !hideIngredientTest })}
                >
                  {!hideIngredientTest ? "View Product Logs" : "View Ingredient Tests"} 
                </Button>
              </Col>
              <Col xs="3">
                {!hideIngredientTest &&
                  (<Fragment>
                     <Select
                      placeholder="Filter by Test Type"
                      className="pageTitleItem"
                      closeMenuOnSelect
                      value={filterTestTypeValue}
                      isMulti={false}
                      options={testTypeList}
                      onChange={e => this.onTestTypeSelect(e)}
                     />
                     <div> 
                        {filterTestTypeValue &&
                            <span className="filterDisplay">
                                Filter - {`Test Type: ${filterTestTypeValue.label}`}
                            </span>
                        }
                     </div>
                </Fragment>)}
                </Col>
              <Col xs="3">
                {!hideIngredientTest &&
                  (<Fragment>
                    <Select
                      placeholder="Filter by data"
                      className="pageTitleItem"
                      closeMenuOnSelect
                      value={filterIngredientValue}
                      isMulti={false}
                      options={sortList}
                      onChange={e => this.onSelectChange(e)}
                    />
                     <div>
                       {filterIngredientValue &&
                         <span className="filterDisplay">
                            Filter - {`Data Type: ${filterIngredientValue.label}`} 
                         </span>
                       }         
                     </div>
               </Fragment> )}
                </Col>
              <Col xs="1">
                {!hideIngredientTest &&
                    <Button className="float-right" onClick={this.onClearFilters}>Clear Filters</Button>
                }
                </Col>
            </Row>
            {!hideIngredientTest 
              ? (
                productData && productData.results.length > 0 &&
                  <Row className="mb-2">
                  {_.map(productData.results, (r, indx) => (
                      <Col xs="3" className="mb-2" key={`rl-${indx}`}>
                          <IngredientDataCard
                          data={r.resultsOverTimeList}
                          title={r.ingredientName}
                          result={r}
                              className={classnames({"failedCOATestResults": r.passed === false}, "coaResult")}
                        />
                      </Col>
                    ))}
                  </Row>
              ) 
              : (
                <Col>
                    <Table size="sm" responsive striped>
                        <thead>
                            <tr>
                                <th>Log Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requestProductLogs && requestProductLogs.length > 0
                                    ? (requestProductLogs.map((l, index) => (
                                    <Fragment>
                                    <tr key={`rq-${l.id}-${index}`}>
                                        <td>
                                            <Row>
                                                <Col >
                                                    <div>
                                                        <span className="primaryTextTitle">Checked By UserName:</span> {l.checkedByUserName && l.checkedByUserName}
                                                    </div>
                                                    <div>
                                                        <span className="primaryTextTitle">Verified At:</span> {l.checkedAt && moment(l.checkedAt).format('MM/DD/YYYY')}
                                                    </div>
                                                    <div>
                                                        <span className="primaryTextTitle">Verification Status: </span> 
                                                        {l.verificationStatusId && (_.find(constant.VerificationStatus, vs => vs.value === l.verificationStatusId)).label }
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div>
                                                        <span className="primaryTextTitle">Batch Number:</span> {l.batchNumber && l.batchNumber}
                                                    </div>
                                                    <div>
                                                        <span className="primaryTextTitle">Sample Name:</span> {l.sampleName && l.sampleName}
                                                    </div>
                                                    <div>
                                                        <span className="primaryTextTitle">Sales Order:</span> {l.salesOrder && l.salesOrder}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </td>
                                    </tr>
                                    </Fragment>
                                ))) : <div>No log history</div>
                            }
                        </tbody>
                    </Table>
                    {/* <Pager {...this.state.pagedList} callBack={this.setPage} /> */}
                </Col>
                )}
          </React.Fragment>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/CoaResults.js